// Handle user data on local localStorage
// react useContext hook was not working on outlook...

const storeUserData = (newRoomSlug, newToken) => {
  localStorage.setItem("roomSlug", JSON.stringify(newRoomSlug));
  localStorage.setItem("token", newToken);
};

const clearStoredUserData = () => {
  localStorage.removeItem("roomSlug");
  localStorage.removeItem("token");
};

const updateUserData = (newRoomSlug) => {
  localStorage.setItem("roomSlug", JSON.stringify(newRoomSlug));
};

const retrieveStoredData = () => {
  const storedRoomSlug = localStorage.getItem("roomSlug");
  const storedToken = localStorage.getItem("token");

  if (storedRoomSlug && storedToken) {
    return {
      roomSlug: JSON.parse(storedRoomSlug),
      token: storedToken,
    };
  } else {
    return null;
  }
};

export { storeUserData, clearStoredUserData, retrieveStoredData, updateUserData };
